import { render, staticRenderFns } from "./item_list.vue?vue&type=template&id=6a7e153c&scoped=true"
import script from "./item_list.vue?vue&type=script&lang=js"
export * from "./item_list.vue?vue&type=script&lang=js"
import style0 from "./item_list.vue?vue&type=style&index=0&id=6a7e153c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7e153c",
  null
  
)

export default component.exports